import React from 'react';
import PropTypes from 'prop-types';
import { helperGetStaticContentUrl } from 'helpers/RouteHelper';
import Style from './ShareMyEmailUpsell.module.scss';
import SignInApple from '../SignInApple';

const ShareMyEmailUpsell = ({
  onAppleLinking,
  onAppleSignIn,
  setAppleEmail,
  setAppleToken,
  setIsAppleEmailShared,
}) => {
  const { signInWithApple_ShareUpsellMessage: upsellMessage } = window.Language;
  const shareImage = helperGetStaticContentUrl('images', 'share-email.png');
  const foxNowAppLogo = helperGetStaticContentUrl('images', 'fox-now-app-icon.png');

  return (
    <main className={Style.container}>
      <div className={Style.innerContainer}>
        <img src={foxNowAppLogo} alt="fox now app icon" />
        <h2>{upsellMessage}</h2>
        <img className={Style.shareImage} src={shareImage} alt="share email" />
        <SignInApple
          isUpsell
          onAppleLinking={onAppleLinking}
          onAppleSignIn={onAppleSignIn}
          setAppleEmail={setAppleEmail}
          setAppleToken={setAppleToken}
          setIsAppleEmailShared={setIsAppleEmailShared}
        />
      </div>
    </main>
  );
};

ShareMyEmailUpsell.propTypes = {
  onAppleLinking: PropTypes.func,
  onAppleSignIn: PropTypes.func,
  setAppleEmail: PropTypes.func,
  setAppleToken: PropTypes.func,
  setIsAppleEmailShared: PropTypes.func,
};

export default ShareMyEmailUpsell;
